"use strict"

import BaseCustomLayer from "./BaseCustomLayer";

export default class BarCustomLayer extends BaseCustomLayer {

  constructor(id, data, options = {}) {
    super(id, BarCustomLayer.name, data, options);
    this.barMargin=options.barMargin||10;
    this.barMaxWidth=options.barMaxWidth||100;
  }

  /**
   * 将数据转化为饼图
   * @param item
   * { point:[112.6,45],values:[[2011,32],[2012,36],[2022,45]],}
   * @param colors
   * ["","",]
   */
  createChart(item, colors) {

    console.log(colors);
    let cvs = document.createElement('canvas');

    cvs.width = this.params.width;//设置canvas宽
    cvs.height = this.params.height;//设置canvas高


    this.goBarChart(item.values,cvs,colors)
    console.log("绘制柱状图")

    let image = new Image();
    image.src = cvs.toDataURL("image/png");
    image.style.cursor="pointer"
    return image;
  }

  goBarChart(dataArr,canvas,colors){
    let that=this;

    // 声明所需变量
    let ctx;
    // 图表属性
    let cWidth, cHeight;
    let originX, originY;
    // 柱状图属性
    let tobalBars, bWidth, maxValue;


    // 获得canvas上下文
    if(canvas && canvas.getContext){
      ctx = canvas.getContext("2d");
    }else {
      return
    }
    initChart(); // 图表初始化
    drawLineLabelMarkers(); // 绘制图表轴、标签和标记
    drawBarAnimate(); // 绘制柱状图的动画

    // 图表初始化
    function initChart(){
      // 图表信息
      cHeight = canvas.height ;
      cWidth = canvas.width ;
      originX =  0;
      originY =  cHeight;

      // 柱状图信息
      tobalBars = dataArr.length;
      bWidth = Math.round( cWidth/tobalBars - that.barMargin );
      if(bWidth>that.barMaxWidth){
        bWidth=that.barMaxWidth;
      }
      maxValue = 0;
      for(let i=0; i<dataArr.length; i++){
        let barVal = parseInt( dataArr[i][1] );
        if( barVal > maxValue ){
          maxValue = barVal;
        }
      }
      maxValue += 10;
    }

    // 绘制图表轴、标签和标记
    function drawLineLabelMarkers(){
      ctx.translate(0.5,0.5);  // 当只绘制1像素的线的时候，坐标点需要偏移，这样才能画出1像素实线
      ctx.font = "12px Arial";
      ctx.lineWidth = 1;
      ctx.fillStyle = "#000";
      ctx.strokeStyle = "#000";
      ctx.translate(-0.5,-0.5);  // 还原位置
    }


    //绘制柱形图
    function drawBarAnimate(){
      for(let i=0; i<tobalBars; i++){
        let barVal = dataArr[i][1];
        let barH = Math.round( cHeight*barVal/maxValue  );
        let y = originY - barH;
        let x = originX + (bWidth+that.barMargin)*i + that.barMargin;

        drawRect( x, y, bWidth, barH, colors[i]);  //高度减一避免盖住x轴
      }
    }

    //绘制方块
    function drawRect( x, y, X, Y,color ){

      ctx.beginPath();
      ctx.rect( x, y, X, Y );
      ctx.fillStyle = color;

      ctx.fill();
      ctx.closePath();
    }

  }
}



// WEBPACK FOOTER //
// ./src/layer/BarCustomLayer.js